import createSagaMiddleware from 'redux-saga';
export default createSagaMiddleware();
